
const download = (url: string, filename: string = '') => {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  document?.body?.appendChild(a);
  a.click();
  a.remove();
};

export default download;
